import { defineMessages } from 'react-intl'

export default defineMessages({
  '2.title': {
    id: 'global.customer.services.2.title',
    defaultMessage: 'Custom Demo',
  },
  '2.description': {
    id: 'global.customer.services.2.description',
    defaultMessage: 'Let your voice talent speak a part of your script to ensure style & pace before full recording.',
  },
  '4.title': {
    id: 'global.customer.services.4.title',
    defaultMessage: 'Extended asset preparation',
  },
  '4.description': {
    id: 'global.customer.services.4.description',
    defaultMessage: 'We help make your assets ready for recording including script, files, pronunciation guides, time codes, etc.',
  },
  '5.title': {
    id: 'global.customer.services.5.title',
    defaultMessage: 'Transcription',
  },
  '5.description': {
    id: 'global.customer.services.5.description',
    defaultMessage: 'Get a ready-to-use script with a speech-to-text conversion of your audio or video. Considerate of language & time codes.',
  },
  '6.title': {
    id: 'global.customer.services.6.title',
    defaultMessage: 'Translation',
  },
  '6.description': {
    id: 'global.customer.services.6.description',
    defaultMessage: 'Need multiple languages? Get a standard voiceover translation or matched to time codes.',
  },
  '8.title': {
    id: 'global.customer.services.8.title',
    defaultMessage: 'Natural Pace',
  },
  '8.description': {
    id: 'global.customer.services.8.description',
    defaultMessage: 'Have your voice talent record your script in a natural pace not time to time codes.',
  },
  '9.title': {
    id: 'global.customer.services.9.title',
    defaultMessage: 'Manuscript sync',
  },
  '9.description': {
    id: 'global.customer.services.9.description',
    defaultMessage: 'Have your voice talent deliver a recording that matches your time coded script.',
  },
  '10.title': {
    id: 'global.customer.services.10.title',
    defaultMessage: 'Paragraph sync',
  },
  '10.description': {
    id: 'global.customer.services.10.description',
    defaultMessage: 'Have your voice talent deliver a recoding that matches the script paragraphs +/- 1 sec of the start & end-time codes.',
  },
  '17.title': {
    id: 'global.customer.services.17.title',
    defaultMessage: 'Live Briefing',
  },
  '17.description': {
    id: 'global.customer.services.17.description',
    defaultMessage: 'Have a 15-minute conversation with your voice talent before their recording & give directions.',
  },
  '18.title': {
    id: 'global.customer.services.18.title',
    defaultMessage: 'Live Session',
  },
  '18.description': {
    id: 'global.customer.services.18.description',
    defaultMessage: 'Experience a full recording session with your voice talent & give directions.',
  },
  '24.title': {
    id: 'global.customer.services.24.title',
    defaultMessage: 'Proof hearing',
  },
  '24.description': {
    id: 'global.customer.services.24.description',
    defaultMessage: 'Have a native speaker verify the language quality of your recording.',
  },
  '26.title': {
    id: 'global.customer.services.26.title',
    defaultMessage: 'Voice concatenation',
  },
  '26.description': {
    id: 'global.customer.services.26.description',
    defaultMessage: 'Have your voice talent record one or several words that can be used to form fluid & varied sentences. ',
  },
  '28.title': {
    id: 'global.customer.services.28.title',
    defaultMessage: 'File Split with Unique Naming',
  },
  '28.description': {
    id: 'global.customer.services.28.description',
    defaultMessage: 'Make it easy to fit sound with visuals with file split. These files are named according to instruction.',
  },
  '29.title': {
    id: 'global.customer.services.29.title',
    defaultMessage: 'File Split with Generic Naming',
  },
  '29.description': {
    id: 'global.customer.services.29.description',
    defaultMessage: 'Make it easy to fit sound with visuals with file split. These files are named after the script + number.',
  },
  '33.title': {
    id: 'global.customer.services.33.title',
    defaultMessage: 'Sound mix master',
  },
  '33.description': {
    id: 'global.customer.services.33.description',
    defaultMessage: 'Get mixing & mastering of your voice over + additional music & effects. Final audio is exported as one file.',
  },
  '34.title': {
    id: 'global.customer.services.34.title',
    defaultMessage: 'Video Layback',
  },
  '34.description': {
    id: 'global.customer.services.34.description',
    defaultMessage: 'Have your voice over, music & effects mixed & masterd + added to your video files.',
  },
  '38.title': {
    id: 'global.customer.services.38.title',
    defaultMessage: 'Style versions',
  },
  '38.description': {
    id: 'global.customer.services.38.description',
    defaultMessage: 'Want options? Have your voice talent record 3-4 different styles that you can choose from.',
  },
  '40.title': {
    id: 'global.customer.services.40.title',
    defaultMessage: 'Post Production Mastering',
  },
  '40.description': {
    id: 'global.customer.services.40.description',
    defaultMessage: 'Have your raw files cleaned, equalized, & treated for productions in multiple platforms. ',
  },
  '43.title': {
    id: 'global.customer.services.43.title',
    defaultMessage: 'Batch deliveries',
  },
  '43.description': {
    id: 'global.customer.services.43.description',
    defaultMessage: 'Receive your audio in batches to stay on top of larger projects.',
  },
  showOnlyRecommended: {
    id:'containers.ProjectPage.components.ProjectServices.showOnlyRecommended',
    defaultMessage:'Show only recommended services '
  },
  showAll: {
    id:'containers.ProjectPage.components.ProjectServices.showAll',
    defaultMessage:'Show all services'
  },
  selectAllRecommended: {
    id:'containers.ProjectPage.components.ProjectServices.selectAllRecommended',
    defaultMessage:'Select all recommended services '
  },

})
